import { NavRoute } from '@/types';

const normalizeBasePath = (basePath?: string) => {
  if (!basePath || basePath === '/' || basePath === '.') {
    return '';
  }

  let pathname;

  try {
    pathname = new URL(basePath, window.location.origin).pathname;
  } catch {
    pathname = basePath;
  }

  const normalizedPath = pathname.replace(/\/+$/, '');

  if (!normalizedPath) {
    return '';
  }

  return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
};

export const APP_BASE_PATH = normalizeBasePath(process.env.REACT_APP_BASE_PATH);

export const AppRoutes = {
  HOME: '/',
  REGULATORY_INTAKE: '/regulatory-intake',
  INTAKE_JOBS: '/regulatory-intake/intake-jobs',
  INTAKE_JOBS_CASA: '/regulatory-intake/intake-jobs/CASA',
  REGULATORY_INTAKE_DETAILS: '/regulatory-intake/intake-jobs/CASA/:id',
  USER_MANAGEMENT: '/user-management',
  USER_MANAGEMENT_CREATION: '/user-management/create',
  USER_MANAGEMENT_UPDATE: '/user-management/:id/edit',
  LOGIN: '/login',
  INITIAL_PASSWORD: '/invitation',
  PASSWORD_RESET: '/password-reset',
  FORGOT_PASSWORD: '/forgot-password',
  FORBIDDEN: '/403',
  INTERNAL_SERVER_ERROR: '/500',
  NOT_FOUND: '/404',
};

export const ROUTE_LABELS: Record<NavRoute, string> = {
  [AppRoutes.HOME]: 'Home',
  [AppRoutes.REGULATORY_INTAKE]: 'Regulatory Intake',
  [AppRoutes.INTAKE_JOBS]: 'Intake Jobs',
  [AppRoutes.INTAKE_JOBS_CASA]: 'CASA',
  [AppRoutes.USER_MANAGEMENT]: 'User Management',
  [AppRoutes.USER_MANAGEMENT_CREATION]: 'Add User',
  [AppRoutes.USER_MANAGEMENT_UPDATE]: 'Update User',
};

export const ERROR_ROUTES = [
  AppRoutes.FORBIDDEN,
  AppRoutes.INTERNAL_SERVER_ERROR,
  AppRoutes.NOT_FOUND,
];

export const DISABLED_ROUTES: string[] = [AppRoutes.REGULATORY_INTAKE, AppRoutes.INTAKE_JOBS_CASA];
